import React from 'react';
import { Modal, Button } from 'antd';
import './InstructionsModal.css';

const InstructionsModal = ({ isOpen, toggle }) => (
  <Modal
    open={isOpen}
    onCancel={toggle}
    footer={[
      <Button key="start" type="primary" size="large" onClick={toggle}>
        Got it, Let's Start!
      </Button>
    ]}
    title={
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <span style={{ fontSize: '24px' }}>📋</span>
        <span style={{ color: '#000', fontSize: '20px', fontWeight: '600' }}>Onboarding Requirements</span>
      </div>
    }
    width={700}
    className="instructions-modal"
    centered
    bodyStyle={{ padding: 0 }}
  >
    <div className="instructions-modal-body">
      <div className="instructions-content">
        <div className="requirement-section">
          <h4 style={{ color: '#2c3e50', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ color: '#e74c3c' }}>⚠️</span>
            Documents/ Information you will require:
          </h4>
          <div className="document-list">
            <div className="document-item">
              <div className="document-icon">🏢</div>
              <div className="document-details">
                <strong>Active GST Number</strong>
                <p>Valid GST registration certificate</p>
              </div>
            </div>
            <div className="document-item">
              <div className="document-icon">📄</div>
              <div className="document-details">
                <strong>Business PAN</strong>
                <p>Permanent Account Number for business</p>
              </div>
            </div>
            <div className="document-item">
              <div className="document-icon">🚗</div>
              <div className="document-details">
                <strong>Driving License</strong>
                <p>Valid driving license (mandatory for transporters)</p>
              </div>
            </div>
          </div>
        </div>

        <div className="requirement-section">
          <h4 style={{ color: '#2c3e50', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ color: '#27ae60' }}>✅</span>
            Required Steps
          </h4>
          <div className="step-list">
            <div className="step-item">
              <div className="step-number">1</div>
              <div className="step-details">
                <strong>Personal Information</strong>
                <p>Email and phone verification with OTP</p>
              </div>
            </div>
            <div className="step-item">
              <div className="step-number">2</div>
              <div className="step-details">
                <strong>Business Details</strong>
                <p>Business type, nature of business, and document verification</p>
              </div>
            </div>
            <div className="step-item">
              <div className="step-number">3</div>
              <div className="step-details">
                <strong>Address Details</strong>
                <p>Pick your business location from the map</p>
              </div>
            </div>
          </div>
        </div>

        <div className="requirement-section">
          <h4 style={{ color: '#2c3e50', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ color: '#f39c12' }}>💡</span>
            Optional Documents
          </h4>
          <div className="optional-list">
            <div className="optional-item">
              <div className="optional-icon">🏭</div>
              <div className="optional-details">
                <strong>Udyog Aadhaar Number</strong>
                <p>Udyog Aadhaar registration certificate (optional but recommended)</p>
              </div>
            </div>
            <div className="optional-item">
              <div className="optional-icon">🏦</div>
              <div className="optional-details">
                <strong>Bank Details</strong>
                <p>Bank account and IFSC details (not required if you're here to buy)</p>
              </div>
            </div>
          </div>
        </div>

        <div className="requirement-section">
          <h4 style={{ color: '#2c3e50', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ color: '#3498db' }}>ℹ️</span>
            Important Notes
          </h4>
          <div className="notes-list">
            <ul>
              <li>All documents must be valid and not expired</li>
              <li>Mark your exact location on the map for business verification</li>
              <li>If you're a transporter, you must provide a valid driving license</li>
              <li>Bank details are required for sellers but optional for buyers</li>
              <li>Udyog Aadhaar helps in faster verification process</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </Modal>
);

export default InstructionsModal;
